<script setup lang="ts">
import { ref, computed } from 'vue';

import { Promotion } from '@interfaces';
// import { modals } from "@modals";
import { useStore } from '@store';

// import { faExclamationCircle } from "@icons/solid/faExclamationCircle";

export interface Props {
  promotions: Promotion[];
}

const props = defineProps<Props>();

const store = useStore();

const displayMode = computed(() => store.state.displayMode);

// const hovering = ref(false);
const slide = ref(0);
const interval = ref(6_000);
const imgHeight = ref(100);

const promos = computed(() => {
  return props.promotions.map((promo) => {
    const id = promo.id;

    let displayText = '';

    if (displayMode.value === 'mobile' && promo.navbarTextMobile) {
      displayText = promo.navbarTextMobile;
    } else if (promo.navbarText) {
      displayText = promo.navbarText;
    } else if (promo.shortText) {
      displayText = promo.shortText;
    }

    const action = promo.callToAction?.fn ?? null;

    const backgroundColor = promo.navbarBackgroundColor ?? undefined;

    return { id, displayText, action, backgroundColor };
  });
});

const backgroundColor = computed(() => {
  return promos.value[slide.value]?.backgroundColor ?? '#d0571c';
});

// async function showDetails(details: string) {
//   if (!details || typeof details !== "string") return;

//   const options = {
//     title: "",
//     text: details,
//   };

//   await modals.util.generalInfo(options);
// }

function onSlideEnd(value: number) {
  slide.value = value;
}
</script>

<template>
  <div class="promotions">
    <Transition>
      <b-carousel
        v-model="slide"
        v-bind="{ interval, imgHeight }"
        :background="backgroundColor"
        fade
        controls
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide
          v-for="promo in promos"
          :key="promo.id"
          class="promotion-slide"
        >
          <p>
            {{ promo.displayText }}

            <span v-if="promo.action" class="link">
              <a @click="promo.action">Info</a>
            </span>
          </p>
        </b-carousel-slide>
      </b-carousel>
    </Transition>
  </div>
</template>

<style scoped lang="scss">
.promotions {
  height: 55px;
  width: 100%;

  .carousel-item {
    -webkit-transition: background-color 1000ms linear;
    -ms-transition: background-color 1000ms linear;
    transition: background-color 1000ms linear;
  }
}

.promotion-slide {
  position: relative;
  min-height: 55px;

  p {
    margin-bottom: -25px;
  }
}

.link {
  margin-left: 10px;
  color: #ffd694;
  border: 1px solid #ffd694;
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 0.8em;

  &:hover {
    opacity: 0.8;
    cursor: pointer;
    background-color: #ffd694;
    color: #d0571c;
  }
}
</style>
